<template>
  <div class="learingCourseClassic">
    <backHeader back-addr="/index"></backHeader>
    
    <div style="height:10px;"></div>
    <ul>
      <li v-for="item in classicTypes"  @click="goClassicItem(item.id)" style="text-align:left;font-size:16px;padding-left:10px;background:white;"><span style="line-height:40px;font-size:16px;">{{item.name}}</span><crossLine></crossLine></li>
    </ul>
    <div style="height:40px;"></div>
  </div>
</template>
<script>

import Vue from "vue";

import openUrl from "./../utils/openUrl";

import crossLine from "./../components/cross-line.vue";
import backHeader from "./../components/back-header.vue";
import commonHeader from "./../components/common-header.vue";
// import IndexApi from '../api/learingInd.js'
import cfg from "./../utils/config";
import axios from "axios";
import Addr from "./../utils/getAPI";
import store from "@/store/index";
import { Toast } from "mint-ui";

export default {
  name: "learingCourseClassic",
  data() {
    return {
      
      heightSize: 160,

      classics: [
        {
          name: "伍连德专题",
          imgurl: "http://wykcug.com:8082/static/classic/wuliande.jpg",
          id: 1
          // ,
          // link: "http://blog.sina.com.cn/s/blog_4fc7197d01015t45.html"
        },
        {
          name: "于维汉专题",
          imgurl: "http://wykcug.com:8082/static/classic/yuweihan.png",
          id: 2
          // ,
          // link: "http://blog.sina.com.cn/s/blog_4fc7197d01015t45.html"
        },
         {
          name: "全面从严治党专题",
          imgurl: "http://wykcug.com:8082/static/classic/zhili.jpg",
          id: 3
          // ,
          // link: "http://blog.sina.com.cn/s/blog_4fc7197d01015t45.html"
        },
        {
          name: "颜色革命",
          imgurl: "http://wykcug.com:8082/static/classic/geming.jpg",
          id: 4
          // ,
          // link: "http://blog.sina.com.cn/s/blog_4fc7197d01015t45.html"
        },
        {
          name: "苏联解体",
          imgurl: "http://wykcug.com:8082/static/classic/sulian.jpg",
          id: 5
          // ,
          // link: "http://blog.sina.com.cn/s/blog_4fc7197d01015t45.html"
        },
        {
          name: "中美贸易战",
          imgurl: "http://wykcug.com:8082/static/classic/zhongmei.jpg",
          id: 6
          // ,
          // link: "http://blog.sina.com.cn/s/blog_4fc7197d01015t45.html"
        }
        // ,
        // {
        //     name: "时代楷模-黄大年",
        //     url: require("./img/classic/1.jpg"),
        //     link: "http://www.12371.cn/special/hdn/"
        // },
        // {
        //     name: "教师楷模 时代英雄-张丽莉",
        //     url: require("./img/classic/zhanglili.png"),
        //     link: "http://news.cntv.cn/special/sdyxzhanglili/index.shtml?eqxk"
        // }
      ],
      classicTypes: [
        {
          name: "习近平新时代中国特色社会主义思想专题辅导课案例",
          id: "1"
        },
        {
          name: "毛泽东思想和中国特色社会主义体系概论案例",
          id: "2"
        },
        {
          name: "中国近代史纲要案例",
          id: "3"
        },
        {
          name: "思想道德修养与法律基础案例",
          id: "4"
        },
        // {
        //   name: "形势与政策",
        //   id: "5"
        // },
        {
          name: "马克思主义基本原理概论案例",
          id: "6"
        }
      ],
  
      imgBaseUrl: cfg.imgBaseUrl,
   
    };
  },
  methods: {
    
    goClassicItem(id) {

      console.log("got it");
      this.$router.push({
        path: "/classicItem",
        query: {
          itemId: id
        }
      });
    },
    
  },
  created: function() {
    
  },
  mounted: function() {
    
  },
  components: {
    crossLine,
    commonHeader,
    backHeader
  }
};
</script>

<style lang="scss">
@import "../assets/baseScss";
.mint-navbar .mint-tab-item.is-selected {
  color: #e70202 !important;
  border-bottom: 2px solid #e70202 !important;
}

.banner {
  background-size: cover;
  width: 100%;
  min-height: 100%;
}

.learingCourseClassic {
  font-weight:bold;
  color:rgb(68, 85, 102)!important;
  .courseItem {
    .item {
      display: flex;
      padding: 15px 15px 0px;

      .ico {
        flex: 1;
        margin-right: 10px;
      }
      .info {
        flex: 2;
        position: relative;
        .tit {
          text-align: left;
          height: 40px;
          line-height: 40px;
          overflow: hidden;
        }
        .speed {
          display: flex;
          font-size: 14px;
          line-height: 30px;
          margin-top: 5px;
          width: 100%;
          a {
            flex: 2;
            color: $cl0;
            text-align: right;
            font-weight: 500;
            i:before {
              position: relative;
              top: 1px;
            }
          }
          .mt-progress {
            flex: 3;
            color: $cl9;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/module-course/index-classic.vue